import React from 'react';
import { Dialog, DialogContent } from "@mui/material";

export default function RefreshPOSMenu({ runApi, posOpen }) {

    const handleNo = () => {
        runApi(false)
    }
    const handleYes = () => {
        runApi(true)
    }
    return (
        <div>

            <Dialog open={posOpen} >
                <DialogContent sx={{ borderRadius: "20px" }} >
                    <div className='row' >
                        <p>Would you like to update your Menu?</p>
                    </div>
                    <div className='row' style={{ marginTop: '20px' }}>
                        <div className='col-6 text-start'>
                            <button className='submit' onClick={handleNo} style={{ width: "100px", height: "30px", background: "#e0e0e0", color: 'black' }}>No</button>
                        </div>

                        <div className='col-6 text-end'>
                            <button className='submit' onClick={handleYes} style={{ width: "100px", height: "30px", margin: "0 10px 0 0" }}>Yes</button>
                        </div>
                    </div>


                </DialogContent>
            </Dialog >

        </div>
    );
};
